import templateUrl from "emun.order/vendor-shipment-prompt.htm";
import VendorShipmentPromptController from "emun.order/vendor-shipment-prompt.controller";
import open from "webmodals/open";

let VendorShipmentPrompt = options => {
  let modalInstance = open({
    size: options.size || "lg",
    templateUrl: options.templateUrl || templateUrl,
    controller: VendorShipmentPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default VendorShipmentPrompt;
